import { data } from "react-router-dom";

const initialState = {
    carreras: {
      loading: false,
      data: [],
      error: null,
    },
    campus: {
      loading: false,
      data: [],
      error: null,
    },
    turnos: {
      loading: false,
      data: [],
      error: null,
    },
    // Precio de matrícula en DOS slots: cada respuesta de getCoste se guarda segun el
    // tipoBonificacion con que se pidio. Asi una respuesta "normal" nunca pisa a la de
    // comunidad (antes habia un solo slot last-write-wins y el precio comunidad se perdia).
    // cargado: ya hubo una respuesta (ok o error) para el pedido vigente. Sin esto, "todavía no se
    // pidió" y "se pidió y vino vacío" eran indistinguibles (data: [] en los dos casos).
    valor: {
      normal:    { loading: false, data: [], error: null, cargado: false },
      comunidad: { loading: false, data: [], error: null, cargado: false },
    },
    anioCarrera:
    {
      loading: false,
      data: [],
      error: null,
    },
    requerimientos: {
      loading: false,
      data: [],
      error: null,
    },
    // Fechas de ingreso que ofrece NBAPI para la entidad (T-2026-158). cargado: ya hubo respuesta
    // (ok o error); hasta entonces el combo espera vacío en vez de mostrar fechas de otra entidad.
    fechasIngreso: { loading: false, data: [], error: null, cargado: false },
  };
  
  const CarrerasReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'LOAD_CARRERAS_REQUEST':
        return {
          ...state,
          carreras: {
            ...state.carreras,
            loading: true,
            error: null,
          },
        };
  
      case 'LOAD_CARRERAS_SUCCES':
        return {
          ...state,
          carreras: {
            ...state.carreras,
            loading: false,
            error: null,
            data: action.payload,
          },
        };
  
      case 'LOAD_CARRERAS_FAIL':
        return {
          ...state,
          carreras: {
            ...state.carreras,
            loading: false,
            error: action.payload,
          },
        };
  
      case 'LOAD_CAMPUS_REQUEST':
        return {
          ...state,
          campus: {
            ...state.campus,
            loading: true,
            error: null,
          },
        };
  
      case 'LOAD_CAMPUS_SUCCES':
        return {
          ...state,
          campus: {
            ...state.campus,
            loading: false,
            error: null,
            data: action.payload,
          },
        };
  
      case 'LOAD_CAMPUS_FAIL':
        return {
          ...state,
          campus: {
            ...state.campus,
            loading: false,
            error: action.payload,
          },
        };
  
      case 'LOAD_TURNOS_REQUEST':
        return {
          ...state,
          turnos: {
            ...state.turnos,
            loading: true,
            error: null,
          },
        };
  
      case 'LOAD_TURNOS_SUCCES':
        return {
          ...state,
          turnos: {
            ...state.turnos,
            loading: false,
            error: null,
            data: action.payload,
          },
        };
  
      case 'LOAD_TURNOS_FAIL':
        return {
          ...state,
          turnos: {
            ...state.turnos,
            data: [],
            loading: false,
            error: action.payload,
          },
        };
  
      case 'LOAD_VALOR_REQUEST':
        return {
          ...state,
          valor: {
            ...state.valor,
            [action.slot]: { data: [], loading: true, error: null, cargado: false },
          },
        };
  
      case 'LOAD_VALOR_SUCCES':
        return {
          ...state,
          valor: {
            ...state.valor,
            [action.slot]: { data: action.payload, loading: false, error: null, cargado: true },
          },
        };
  
      case 'LOAD_VALOR_FAIL':
        return {
          ...state,
          valor: {
            ...state.valor,
            [action.slot]: { ...state.valor[action.slot], loading: false, error: action.payload, cargado: true },
          },
        };

      // Cambio de fecha/carrera/campus/año: los precios cargados ya no aplican.
      case 'CLEAR_VALOR':
        return {
          ...state,
          valor: {
            normal:    { loading: false, data: [], error: null, cargado: false },
            comunidad: { loading: false, data: [], error: null, cargado: false },
          },
        };

        case 'LOAD_ANIOCARRERA_REQUEST':
          return {
            ...state,
            anioCarrera: {
              ...state.anioCarrera,
              loading: true,
              error: null,
            },
          };
    
        case 'LOAD_ANIOCARRERA_SUCCESS':
          return {
            ...state,
            anioCarrera: {
              ...state.anioCarrera,
              loading: false,
              error: null,
              data: action.payload,
            },
          };
    
        case 'LOAD_ANIOCARRERA_FAIL':
          return {
            ...state,
            anioCarrera: {
              ...state.anioCarrera,
              loading: false,
              error: action.payload,
              data:[]
            },
          };

          case 'LOAD_REQUERIMIENTOS_REQUEST':
          return {
            ...state,
            requerimientos: {
              ...state.requerimientos,
              loading: true,
              error: null,
            },
          };

          case 'LOAD_REQUERIMIENTOS_SUCCESS':
            return {
              ...state,
              requerimientos: {
                ...state.requerimientos,
                loading: false,
                data: action.payload,
                error: null,
              },
            };
      
          case 'LOAD_REQUERIMIENTOS_FAIL':
            return {
              ...state,
              requerimientos: {
                ...state.requerimientos,
                loading: false,
                data: [],
                error: action.payload,
              },
            };

      case 'LOAD_FECHAS_INGRESO_REQUEST':
        return {
          ...state,
          fechasIngreso: { ...state.fechasIngreso, loading: true, error: null, cargado: false },
        };

      case 'LOAD_FECHAS_INGRESO_SUCCESS':
        return {
          ...state,
          fechasIngreso: { loading: false, data: action.payload, error: null, cargado: true },
        };

      case 'LOAD_FECHAS_INGRESO_FAIL':
        return {
          ...state,
          fechasIngreso: { loading: false, data: [], error: action.payload, cargado: true },
        };

      default:
        return state;
    }
  };
  
  export default CarrerasReducer;
  